import { verdictMeta, verdictOrder } from '@/lib/verdict';

export default function VerdictGuide() {
  return (
    <section className="bg-background-50" aria-labelledby="verdict-guide-title">
      <div className="container-page py-12 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">判定说明</p>
            <h2 id="verdict-guide-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              四种判定，看清一条料的成色
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            每条爆料都会给出一个判定和一个可信度评分。判定看的是证据，评分看的是证据够不够多、够不够硬。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {verdictOrder.map((key) => {
            const meta = verdictMeta[key];
            return (
              <div
                key={key}
                className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
              >
                <span className={`inline-flex w-10 h-10 items-center justify-center rounded-lg text-lg ${meta.badge}`}>
                  <i className={meta.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{meta.label}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{meta.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}